//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventShiftCard from "./event_shift_card.vue";
import EventFilters from "./event_filters.vue";

export default {
  name: "event_shifts",
  props: {
    page_length: {
      default: 9
    },
  },
  data() {
    return {
      available_shifts: [],
      available_shifts_load_counter: 0,
      user_shifts: [],
      user_shifts_load_counter: 0,
      settings: {'defer_shift_without_ticket': false, 'defer_shift_with_special': false},
      volunteer: {},
      volunteer_load_counter: 0,
      training_completed: [],
      selected_event: null,
      selected_team: null,
      selected_weekday: null,
      selected_timeslot: null,
      hide_unavailable: true,
      priority_shifts: false
    }
  },
  created() {
    this.get_user_volunteer_info();
    this.get_event_shifts();
    this.get_user_event_shifts();
    this.get_settings();
  },
  methods: {
    reload_shifts: function() {
      this.available_shifts = [];
      this.user_shifts = [];
      this.get_user_volunteer_info();
      this.get_event_shifts();
      this.get_user_event_shifts();
    },
    get_event_shifts: function () {
      let me = this;
      me.available_shifts_load_counter++;
      frappe.call({
              method: 'event_management.www.event-shifts.index.get_shift_list',
              args: {
                'event': this.selected_event,
                'team': this.selected_team,
                'weekday': (this.selected_weekday === 'All') ? null : this.selected_weekday,
                'timeslot': (this.selected_timeslot === 'All') ? null : this.selected_timeslot,
                user_shifts: false,
                priority_shifts: this.priority_shifts,
                hide_unavailable: this.hide_unavailable,
                limit_start: this.available_shifts.length,
                limit_page_length: this.page_length
              },
              callback: function (r) {
                let shifts = r.message;
                if (shifts) {
                  me.available_shifts = me.available_shifts.concat(shifts);
                }
              },
              always: function () {
                me.available_shifts_load_counter--;
              },
              // freeze the screen until the request is completed
              freeze: true,
              freeze_message: (__('Please wait') + '...')
            });

    },
    get_user_event_shifts: function() {
       let me = this;
       me.user_shifts_load_counter++;
       frappe.call({
              method: 'event_management.www.event-shifts.index.get_shift_list',
              args: {
                user_shifts: true,
                priority_shifts: false,
                hide_unavailable: false,
                limit_start: this.user_shifts.length,
                limit_page_length: this.page_length
              },
              callback: function (r) {
                let shifts = r.message;
                if (shifts) {
                  me.user_shifts = shifts
                }
              },
              always: function () {
                me.user_shifts_load_counter--;
              },
              // freeze the screen until the request is completed
              freeze: true,
              freeze_message: (__('Please wait') + '...')
            });
    },
    get_user_volunteer_info: function () {
      let me = this;
      me.volunteer_load_counter++;
      frappe.call({
              method: 'event_management.www.event-shifts.index.get_user_volunteer',
              args: {
              },
              callback: function (r) {
                let volunteer = r.message;
                if (volunteer) {
                  me.volunteer = volunteer
                }
              },
              always: function () {
                me.volunteer_load_counter--;
              },
              // freeze the screen until the request is completed
              freeze: true,
              freeze_message: (__('Please wait') + '...')
            });
      me.volunteer_load_counter++;
      frappe.call({
                    method: 'event_management.www.event-shifts.index.get_user_training_completed',
                    args: {
                    },
                    callback: function (r) {
                      let training_completed = r.message;
                      if (training_completed) {
                        me.training_completed = training_completed;
                      }
                    },
                    always: function () {
                      me.volunteer_load_counter--;
                    },
                    // freeze the screen until the request is completed
                    freeze: true,
                    freeze_message: (__('Please wait') + '...')
                  });
    },
    get_settings: function () {
      let me = this;
      frappe.call({
              method: 'event_management.www.event-shifts.index.get_settings',
              args: {
              },
              callback: function (r) {
                let settings = r.message;
                if (settings) {
                  me.settings = settings
                }
              }
            });
    }
  },
  computed: {
    show_more_btn: function () {
      return this.available_shifts.length> 0 && (this.available_shifts.length % this.page_length) === 0;
    }
  },
  watch: {
  },
  components: {
    EventShiftCard,
    EventFilters
  },
}
